import "./loginSignup.scss";
import signup_bg from "../../assets/img/signup_bg.jpg";
import logo from "../../assets/img/logo.svg";
import password_show from "../../assets/img/password_show.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import Loading from 'react-fullscreen-loading';
import { signUp } from "../../redux/action";
import { Link } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";


const Signup = () => {
    const navigate = useNavigate()
    // __________ selector from redux __________
    const selector = useSelector((state) => state.GET_SIGNUP_REDUCER)
    // __________ selector from redux __________

    const [showModal1, setShowModal1] = useState(false);
    const handleClose1 = () => {
        setShowModal1(false);
    };

    const [showModal2, setShowModal2] = useState(false);
    const handleClose2 = () => {
        setShowModal2(false);
    };
    // __________ state management __________
    const [consent, setConsent] = useState(false)
    const [emailError, setEmailError] = useState(null)
    const [passwordError, setPasswordError] = useState(null)
    const [constError, setConstError] = useState(null)
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const [signupDetail, setSignupDetail] = useState(
        {
            email: null,
            password: null
        }
    )
    // __________ state management __________


    // __________ handleFunction __________

    const handleEmail = (e) => {
        setSignupDetail(prevState => ({
            ...prevState, // Spread the previous state to keep the password
            email: e.target.value  // Update the email
        }));
    }

    const handlePassword = (e) => {
        setSignupDetail(prevState => ({
            ...prevState, // Spread the previous state to keep the password
            password: e.target.value // Update the email
        }));
    }

    const handleSignUpEffect = () => {
        if (selector.error == null) {
            if (selector.data != null) {
                toast.success(selector.message, {
                    autoClose: 2000,
                    position: "bottom-right",
                })
                setTimeout(() => {
                    navigate("/subscription"); // Navigate after 2 seconds
                    // navigate("/patient-information");
                }, 1000);
            }
        } else {
            toast.error(selector.error, {
                autoClose: 2000,
                position: "bottom-right",
            })
        }
    }

    // __________ handleFunction __________


    // __________ Redux Action __________
    const dispatch = useDispatch()

    const handleSubmitFormLogin = (event) => {
        let isError = false
        event.preventDefault();
        setEmailError("");
        setPasswordError("");
        setConstError("")

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!signupDetail.email) {
            setEmailError("* Email is required.");
            isError = true;
        } else if (!emailRegex.test(signupDetail.email)) {
            setEmailError("* Invalid email format.");
            isError = true;
        }

        const passwordStrengthRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

        // Password validation (for example, a minimum of 8 characters)
        if (!signupDetail.password) {
            setPasswordError("* Password is required.");
            isError = true;
        } else if (signupDetail.password.length < 8) {
            setPasswordError("* Password must be at least 8 characters long.");
            isError = true;
        } else if (!passwordStrengthRegex.test(signupDetail.password)) {
            setPasswordError("* Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character.");
            isError = true;
        }

        if (isError) return;

        if (consent) {
            signupDetail.email = signupDetail.email.trim().toLowerCase();
            dispatch(signUp(signupDetail))
        } else {
            setConstError('* Accept Terms and Conditions ')
        }
    }
    // __________ Redux Action __________



    useEffect(() => {
        handleSignUpEffect()
    }, [selector])

    useEffect(() => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            if (localStorage.getItem("role") == "admin") {
              navigate("/admin/prompts");
            } else {
              navigate("/");
            }
        }
    }, []);

    return (
        <>

            {selector.isLoading && <Loading loading background="rgba(236, 240, 241, 0.7)" loaderColor="#3498db" />}


            <section class="login_signup_wrapper">
                <div class="img_colm">
                    <div href="" class="back_btn" onClick={() => navigate('/')}>
                        <i class="fa-solid fa-chevron-left"></i>
                    </div>
                    <div class="img_block">
                        <img src={signup_bg} alt="" />
                    </div>
                </div>
                <div class="form_colm">
                    <div class="inner_block">
                        <img src={logo} alt="" class="logo_img" />
                        <h1>Sign Up</h1>
                        <p>Join us and experience a revolutionary way to manage patient files and generate comprehensive
                            reports.</p>

                        <form onSubmit={handleSubmitFormLogin} class="form_block">
                            <div class="form_field">
                                <div class="input_grp">
                                    <label for="">Email</label>
                                    <input type="text" onChange={handleEmail} />
                                </div>
                                <span className="red_error">{emailError}</span>
                            </div>
                            <div class="form_field">
                                <div class="input_grp">
                                    <label for="">Password</label>
                                    <div class="pass_field">
                                        <input type={isPasswordVisible ? "text" : "password"} onChange={handlePassword} />
                                        <span class={`show_hide_btn ${!isPasswordVisible ? 'hide' : ''}`} onClick={() => setIsPasswordVisible(!isPasswordVisible)}>
                                            <img src={password_show} alt="" />
                                        </span>
                                    </div>
                                    <span className="red_error">{passwordError}</span>
                                </div>
                            </div>
                            <div class="site_row">
                                <div class="input_grp">
                                    <input type="checkbox" id="consentCheckbox" className="customChk-s1" checked={consent} onChange={(e) => setConsent(e.target.checked)} />
                                    {/* <label for="" htmlFor="consentCheckbox" > &nbsp;I have read and agree with the Terms and Conditions and Privacy Policy</label> */}
                                    <label htmlFor="consentCheckbox">
                                        &nbsp;I have read and agree with the{' '}
                                        <button type="button" onClick={() => setShowModal1(true)} className="link-btn-primary">
                                            Terms and Conditions
                                        </button>{' '}
                                        and{' '}
                                        <button type="button" onClick={() => setShowModal2(true)} className="link-btn-primary">
                                            Privacy Policy
                                        </button>.
                                    </label>
                                </div>
                                <span className="red_error">{constError}</span>
                            </div>
                            <div class="btn_block">
                                <button type="submit">Sign up</button>
                            </div>
                            <p>Already have an account? <Link to={'/login'}> &nbsp; Sign In</Link></p>
                        </form>
                    </div>
                </div>
            </section>

            <ToastContainer />



            {/* start: Terms and Conditions modal */}
            <Modal show={showModal1} onHide={handleClose1} centered size="lg" scrollable className="term-privacy-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Terms and Conditions</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h1>Informed Consent for Audio Recording and Data Collection
                        For Use with PsychScribe AI Platform</h1>

                    <div>
                        <h3>
                            Purpose of Consent

                        </h3>
                    </div>
                    <p>As part of providing psychological and psychiatric services, we will audio record our sessions and collect various forms of data to assist in your care. This data will be processed using PsychScribe, an artificial intelligence (AI) platform designed to support clinicians by aiding in diagnostic decision-making, administrative support, and report generation. This consent document explains how your information will be collected, used, stored, and protected in compliance with the Health Insurance Portability and Accountability Act (HIPAA), the General Data Protection Regulation (GDPR), the Data Protection Act, the Australian Privacy Act 1988, and the Australian Privacy Principles (APP).</p>

                    <h3>   How PsychScribe Works</h3>

                    <h5>PsychScribe uses Artificial Intelligence to:</h5>

                    <p>	•	Assist in diagnostic decision-making by suggesting potential provisional diagnoses. However, all final diagnoses are verified by your clinician and require human/user interface. </p>
                    <p>	•	Support administrative tasks, including generating reports and organising data to improve clinical efficiency.</p>
                    <p>	•	Provide automation to enhance the clinician’s ability to manage patient care in a timely manner including making individualised evidence-based treatment recommendations.</p>

                    <p>Please note: PsychScribe’s AI models are trained on anonymized and aggregated data to protect your privacy. The information collected during your sessions is handled with strict security measures to ensure confidentiality. <span style={{ color: 'red' }}>(we need to be clear on how the AI models are trained and whether patient data is retained to train the models) </span></p>

                    <h3>What Data is Collected and Why</h3>

                    <h5>We may collect the following types of information:</h5>

                    <p>•	Audio recordings of your sessions to ensure accurate documentation of conversations and treatment decisions.</p>
                    <p>	•	Session notes, including details about your health, treatment progress, and any relevant medical history.</p>
                    <p>•	Personal information, such as demographic data, which helps in delivering accurate recommendations and tailored care.</p>
                    <p>	•	Treatment reports, which outline the interventions and progress made during your care.</p>
                    <p>	•	Medical reports from other healthcare professionals, relevant to your ongoing care and diagnosis.</p>
                    <p>	•	Psychology reports, containing assessments and diagnostic information that contribute to a comprehensive understanding of your mental health.</p>
                    <p>	•	Standardised psychometric assessment measures, which may include tests like cognitive assessments, mood inventories, and behavioural scales. These assessments provide quantitative data to aid in understanding your cognitive and emotional functioning and help inform your suggested provisional diagnoses and treatment. </p>

                    <h3>This data is collected for the following purposes:</h3>

                    <p>•	To help your clinician make informed decisions about your diagnosis and treatment plan.</p>
                    <p>•	To generate reports and patient letters that provide a structured way for your clinician to monitor your progress over time.</p>
                    <p>•	To improve the accuracy and functionality of PsychScribe’s AI system, which assists clinicians in making evidence-based decisions <span style={{ color: 'red' }}> (is data retained?).</span></p>
                    <p>	•	To integrate medical, psychological, and standardised psychometric data into a comprehensive care plan that addresses your specific needs.</p>

                    <h3>How Your Data is Stored</h3>

                    <h5>Your data will be stored in compliance with the following regulations:</h5>

                    <p>•	HIPAA (for US-based patients) mandates that your data is stored securely and is accessible only to authorised personnel.</p>
                    <p>•	GDPR and the Data Protection Act (for patients in the EU and UK) ensure that your data is collected, processed, and stored lawfully. You have rights to access, correct, and delete your personal information.</p>
                    <p>•	The Australian Privacy Act 1988 and Australian Privacy Principles (APP) (for Australian patients) require that your personal information is handled responsibly and transparently.</p>

                    <p>Your data is stored in encrypted databases within secure, regulated data centres that meet international security standards, ensuring that your information is safeguarded from unauthorised access. <span style={{ color: 'red' }}> (We also need to specify how long data is stored for)</span></p>

                    <h3>How PsychScribe Uses Your Data</h3>

                    <h5>The data collected from your sessions may be used to:</h5>

                    <p>	•	Train PsychScribe’s AI models in an anonymized and aggregated format to enhance system accuracy while ensuring that your personal information remains protected.</p>
                    <p>•	Provide diagnostic suggestions to your clinician, which are then reviewed and confirmed by your clinician before being integrated into your care plan.</p>
                    <p>•	Generate administrative reports to assist your clinician in efficiently managing your case and ensuring timely follow-up on treatment recommendations. </p>

                    <h3>Your Rights and Privacy Protections</h3>

                    <p>•	You have the right to access any data collected about you. However, this will need to be facilitated with your treating clinician and is not a responsibility of PsychScribe. </p>
                    <p>•	You can request corrections to any inaccurate data. However, this will need to be facilitated with your treating clinician and is not a responsibility of PsychScribe as the final report and patient information will require final editing on your treating clinician’s behalf.  </p>
                    <p>•	You may request that all or some of your data is deleted, subject to legal and regulatory obligations. However, this will need to be facilitated with your treating clinician and is not a responsibility of PsychScribe.</p>
                    <p>•	Your data will not be shared with third parties without your explicit consent, except where required by law.</p>

                    <hr />
                    <h3>Consent to Record and Collect Data</h3>

                    <p>By signing this form, you consent to the audio recording of your sessions and the collection of data, as outlined above, for the purposes of providing and enhancing your care through the PsychScribe platform. You understand that the AI platform is used as a support tool and that all diagnostic and treatment decisions will be made by your clinician.</p>

                    <p>Contact Information</p>

                    <p>If you have any questions or concerns about how your data is being handled, or if you wish to exercise any of your rights, please contact:</p>

                    <p>[Practice Name]</p>
                    <p>[Clinician’s Name]</p>
                    <p>[Contact Details]</p>

                    <p>Patient Acknowledgement</p>

                    <p>I have read and understood the information provided regarding the collection, storage, and use of my data in conjunction with the PsychScribe AI platform. I consent to the recording and collection of my data as described. I understand that I may withdraw my consent at any time by contacting my clinician.</p>

                    <p>Patient Name: ______________________________________</p>
                    <p>Date: _____________________________________________</p>
                    <p>Signature: __________________________________________</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose1}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* end: Terms and Conditions modal */}

            {/* start: Privacy Policy modal */}
            <Modal show={showModal2} onHide={handleClose2} centered size="lg" scrollable className="term-privacy-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Privacy Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h1>  Consent Form for Uploading De-Identified Reports to PsychScribe AI Platform</h1>

                    <h3>Introduction:</h3>
                    <p>As part of your engagement with the PsychScribe AI platform, you may upload de-identified patient reports to assist in the training of AI models. These models are used to learn report-writing styles, tone, and formats to enhance the accuracy of automated report generation and improve clinical support tools.
                    </p>

                    <p>This consent form ensures that you, as a clinician, are aware of your legal and ethical responsibilities regarding the use of de-identified data across various jurisdictions, including Australia, the UK, Europe, and the United States.</p>

                    <p>Acknowledgement of Legal and Ethical Responsibilities</p>

                    <p>By signing this form, you acknowledge that you are aware of and agree to the following responsibilities:</p>

                    <p>1. Compliance with Data Privacy Laws</p>

                    <p>You understand that, even when patient data is de-identified, you must comply with relevant data privacy laws in the jurisdiction where you practice, including but not limited to:</p>

                    <p>Australia:</p>
                    <p>	•	The Australian Privacy Act 1988 and Australian Privacy Principles (APPs).</p>


                    <p>United Kingdom:</p>
                    <p>	•	The UK Data Protection Act 2018 and General Data Protection Regulation (GDPR).</p>

                    <p>Europe:</p>
                    <p>	•	The General Data Protection Regulation (GDPR).</p>

                    <p>United States:</p>
                    <p>	•	The Health Insurance Portability and Accountability Act (HIPAA).</p>

                    <p>You acknowledge that de-identified reports must not contain any information that could lead to the re-identification of the individual and that you are responsible for ensuring all identifying data (e.g., names, contact information, addresses, dates of birth) have been thoroughly removed prior to uploading.</p>

                    <hr />
                    <p>2. Informed Consent from Patients</p>

                    <p>•	While de-identified data may be used for the training of the PsychScribe AI model, you understand that it is best practice to inform patients, where possible, about the use of their anonymised data for AI training.</p>
                    <p>•	You agree to obtain informed consent from patients to use their data for secondary purposes, including AI model training, wherever applicable and feasible.</p>
                    <hr />
                    <p>3. Confidentiality and Security</p>

                    <p>•	You are aware that de-identified patient reports will be uploaded into an encrypted and secure database where the information will be processed solely for the purpose of training AI models within PsychScribe.</p>
                    <p>•	You confirm that all uploaded data has been properly anonymised and meets the legal and ethical standards of data minimisation, ensuring that only necessary information is uploaded for the intended purpose.</p>
                    <hr />
                    <p>4. Ethical Responsibilities </p>

                    <p>You acknowledge that, as a practicing psychologist or psychiatrist, you are bound by the ethical codes of your professional body, including:</p>

                    <p>Australia:</p>
                    <p>•	The Australian Psychological Society (APS) Code of Ethics or equivalent professional guidelines.</p>

                    <p>United Kingdom:</p>
                    <p>•	The British Psychological Society (BPS) Code of Ethics and Conduct or equivalent professional guidelines.</p>

                    <p>Europe:</p>
                    <p>•	The European Federation of Psychologists’ Associations (EFPA) Meta-Code of Ethics or equivalent professional guidelines.</p>

                    <p>United States:</p>
                    <p>•	The American Psychological Association (APA) Code of Ethics or equivalent professional guidelines.</p>

                    <p>You understand that, in line with these ethical obligations, you must ensure that the use of de-identified reports serves the best interest of patients and promotes beneficence without causing harm to the individual.</p>


                    <hr />
                    <p>5. Data Protection Impact Assessment (DPIA)</p>

                    <p>For jurisdictions where it applies (e.g., under GDPR), you are aware that a Data Protection Impact Assessment (DPIA) may be required before engaging in data processing activities involving de-identified data, especially for high-risk processing like AI training.</p>
                    <hr />
                    <p>6. Accountability and Transparency</p>

                    <p>You acknowledge your responsibility to ensure the transparency of data use and processing practices, including informing any relevant parties (such as patients, regulatory bodies, or institutions) about the nature and purpose of data collection and AI training.</p>

                    <hr />

                    <p>Agreement</p>

                    <p>By signing below, you agree to the terms and conditions outlined in this document and confirm that you have taken appropriate steps to comply with the legal and ethical requirements associated with uploading de-identified reports to the PsychScribe platform.</p>

                    <p>You acknowledge that you are responsible for ensuring that any de-identified patient data you upload is in full compliance with the relevant data protection and privacy regulations in your jurisdiction.</p>

                    <p>Clinician’s Name: ______________________________________</p>
                    <p>Professional Title (Psychologist/Psychiatrist): ______________________________________</p>
                    <p>Country of Practice: ______________________________________</p>
                    <p>Date: ________________________________________________</p>
                    <p>Signature: ____________________________________________</p>

                    <p>Contact Information for Queries:</p>

                    <p>If you have any questions regarding this consent form or your legal and ethical responsibilities, please contact:</p>
                    <p>
                        PsychScribe Support Team</p>
                    <p>Email: [support@psychscribe.com]</p>
                    <p>Phone: [+1-XXX-XXX-XXXX]</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose2}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* end: Privacy Policy modal */}
        </>
    )
}

export default Signup
